import { useSyncExternalStore } from "react";

// Whether dark mode is currently applied — the `dark` class on <html>, kept in
// sync by useApplyTheme. Observing the applied class (rather than recomputing the
// rule) means consumers reflect exactly what is painted, across toggles and live
// OS color-scheme changes.
function subscribe(onChange: () => void) {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });
  return () => observer.disconnect();
}

export function useIsDark(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => document.documentElement.classList.contains("dark"),
    () => false // SSR / pre-hydration: assume light, matching the no-flash default
  );
}
